import { getFunctions, httpsCallable } from "firebase/functions";

const callableFunctions = getFunctions();

export async function sendEmailVerification() {
  const verifyEmailFunc = httpsCallable(callableFunctions, "sendVerificationEmail");
  await verifyEmailFunc();
}